import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";

export const _updateClientNewAnnouncement = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.clientUpdateNewAnnouncement,
    method: "POST",
    data: data,
  };
  return await post(request);
};

export const _fetchClientAllAnnouncementList = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.clientAllAnnouncementList,
    data: data,
  };
  return await post(request);
};
